import * as React from 'react'

import { Box, CollapsableCard, Text, TogglerCheckbox } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useEffect } from 'modules/core/hooks/useEffect'
import i18n from 'modules/core/lib/i18n'

import useUpdateAttendanceSetting from 'modules/attendance/components/SettingItemPage/TimeTracking/hooks/useUpdateAttendanceSetting'
import AttendanceSettingForm from 'modules/attendance/lib/forms/AttendanceSettingForm'
import type AttendanceSetting from 'modules/attendance/store/models/AttendanceSetting'

interface Props {
  attendanceSetting: AttendanceSetting
}

const createSettingForm = (setting: AttendanceSetting) =>
  new AttendanceSettingForm({
    overtime_authorization: setting.attributes.overtime_authorization,
  })

const OvertimeAuthorization = ({ attendanceSetting }: Props) => {
  const [settingForm, setSettingForm] = React.useState(createSettingForm(attendanceSetting))
  const overtimeAuthorizationField = settingForm.get('overtime_authorization')
  const { updateSetting } = useUpdateAttendanceSetting(settingForm, attendanceSetting)

  useEffect(() => {
    setSettingForm(createSettingForm(attendanceSetting))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [attendanceSetting.attributes.id])

  const onChange = (newValue: boolean) => {
    overtimeAuthorizationField.set(newValue)
    updateSetting()
  }

  return (
    <CollapsableCard
      open={false}
      Card={
        <Box
          gap="s8"
          extra={{ 'data-intercom-target': 'attendance-timesheet-overtime-authorization' }}
        >
          <Box flexDirection="row" justifyContent="spaceBetween">
            <Text.Normal weight="medium">
              {i18n.t('time_tracking.settings.overtime.authorization.title')}
            </Text.Normal>
            <TogglerCheckbox
              value={overtimeAuthorizationField.value}
              onChange={(newValue) => onChange(newValue)}
              labelBefore
            />
          </Box>
          <Text.Normal>
            {i18n.t('time_tracking.settings.overtime.authorization.description')}
          </Text.Normal>
        </Box>
      }
      Content={<></>}
    />
  )
}

export default observer(OvertimeAuthorization)
